import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-table-wrap',
  templateUrl: './table-wrap.component.html',
  styleUrls: ['./table-wrap.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableWrapComponent {
  @Input() name!: string;
  @Input() dates?: string[];
  @Input() count?: number | null | undefined;
  @Input() page!: number;
  @Output() onGetPrevPage: EventEmitter<void> = new EventEmitter<void>();
  @Output() onGetNextPage: EventEmitter<void> = new EventEmitter<void>();

  checkYears(): string {
    if (!this.dates) return '';
    return `${this.dates![0]} - ${this.dates![this.dates!.length - 1]}`;
  }
}
